import styled from 'styled-components';

const ScrollablePane = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`;

export { ScrollablePane };
